import { render, staticRenderFns } from "./TenderCenter.vue?vue&type=template&id=2a4fc362&scoped=true&"
import script from "./TenderCenter.vue?vue&type=script&lang=js&"
export * from "./TenderCenter.vue?vue&type=script&lang=js&"
import style0 from "./TenderCenter.vue?vue&type=style&index=0&id=2a4fc362&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4fc362",
  null
  
)

export default component.exports